import React from 'react'

import PurchaseDocumentTable from './PurchaseTable/PurchaseDocumentTable'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

import { ContractDocumentsError } from '../types'

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchase: Purchase
    role: string
    onPurchaseDocuments: (have_purchase_documents: boolean) => void
}

const PurchaseDocuments: React.FC<Props> = (props) => {
    return (
        <Section title="Документы">
            <div className="flex flex-col w-full gap-x-5 space-y-3">
                <div className="flex flex-col w-full gap-x-5 ">
                    <div className={`flex flex-col min-w-[200px]`}>
                        <PurchaseDocumentTable
                            theme={props.theme}
                            purchaseAction={props.purchaseAction}
                            purchaseGuid={props.purchaseGuid}
                            role={props.role}
                            onPurchaseDocuments={props.onPurchaseDocuments}
                        />
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default PurchaseDocuments
